import { Segmented } from 'antd'
import { SegmentedValue } from 'antd/lib/segmented'
import { FC } from 'react'

import { BitazzaText } from '../../../../../components'
import Styles from './Chart.module.scss'

interface Props {
    onTimeHandler: (value: string) => void
    selected: string
}

export const TimeSegment: FC<Props> = ({ onTimeHandler, selected }) => {
    return (
        <>
            <Segmented
                className={Styles.timestamps}
                value={selected}
                defaultValue={'1W'}
                onChange={(value: SegmentedValue) =>
                    onTimeHandler(value as string)
                }
                options={[
                    {
                        label: (
                            <div className={Styles.labelSegment}>
                                <BitazzaText
                                    content="1D"
                                    format="t14"
                                    color="#fff"
                                    display="block"
                                />
                            </div>
                        ),
                        value: '1D',
                    },
                    {
                        label: (
                            <div className={Styles.labelSegment}>
                                <BitazzaText
                                    content="1W"
                                    format="t14"
                                    color="#fff"
                                    display="block"
                                />
                            </div>
                        ),
                        value: '1W',
                    },
                    {
                        label: (
                            <div className={Styles.labelSegment}>
                                <BitazzaText
                                    content="1M"
                                    format="t14"
                                    color="#fff"
                                    display="block"
                                />
                            </div>
                        ),
                        value: '1M',
                    },
                    {
                        label: (
                            <div className={Styles.labelSegment}>
                                <BitazzaText
                                    content="3M"
                                    format="t14"
                                    color="#fff"
                                    display="block"
                                />
                            </div>
                        ),
                        value: '3M',
                    },
                ]}
            />
        </>
    )
}
